import type { GalleryProject } from '../types/shop';

export const galleryProjects: GalleryProject[] = [
  {
    id: 'silverado-front',
    title: 'Front-end collision',
    vehicle: '2020 Chevrolet Silverado',
    service: 'Collision repair',
    description:
      'Replaced the fender, headlamp assembly, and bumper cover, then color-matched and blended the finish into the door.',
    before: 'https://cdn.magicpatterns.com/patterns/generated-images/988dd5b7-22ce-4035-acea-998c945f34c8.jpg',
    after: 'https://cdn.magicpatterns.com/patterns/generated-images/4596950c-a176-4217-b58c-f5b39da4119b.jpg',
  },
  {
    id: 'accord-rear',
    title: 'Rear-end collision',
    vehicle: '2019 Honda Accord',
    service: 'Collision repair',
    description:
      'Rebuilt the bumper reinforcement, repaired the quarter panel, and refinished in the original tri-coat pearl white.',
    before: 'https://cdn.magicpatterns.com/patterns/generated-images/d5a7594e-05b1-4d76-9775-4e56034371d0.jpg',
    after: 'https://cdn.magicpatterns.com/patterns/generated-images/ce7e1303-4609-4f62-af8d-a5ca2558e671.jpg',
  },
  {
    id: 'explorer-hail',
    title: 'Hail damage',
    vehicle: '2021 Ford Explorer',
    service: 'Paintless dent repair',
    description:
      'More than 60 hail dents removed from the hood without filler or repainting, keeping the original factory finish.',
    before: 'https://cdn.magicpatterns.com/patterns/generated-images/afb118cf-1770-447b-8f10-38d179d820c1.jpg',
    after: 'https://cdn.magicpatterns.com/patterns/generated-images/546c1b71-c45b-40bc-862f-f25cd99940b7.jpg',
  },
  {
    id: 'mazda-doors',
    title: 'Door crease & key scratch',
    vehicle: '2017 Mazda3',
    service: 'Paint & refinishing',
    description:
      'Pulled the crease, repaired the scratch down to bare metal, and refinished both doors with a seamless blend.',
    before: 'https://cdn.magicpatterns.com/patterns/generated-images/cce11de4-d80e-4cf9-b627-21f1cb4d3be8.jpg',
    after: 'https://cdn.magicpatterns.com/patterns/generated-images/41c3822c-50aa-43bd-b23a-42ea0a86b68f.jpg',
  },
];
